interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage' | 'BreadcrumbList';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const getDefaultSchema = () => {
    switch (type) {
      case 'Organization':
        return {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: '无遮韩国免费漫画大全',
          url: 'https://manhwa-free.com',
          description: '无遮韩国免费漫画大全 - 最全面的韩漫漫画网站，提供免费在线阅读韩漫服务，网站稳定性高确保访问顺畅。',
          logo: 'https://manhwa-free.com/logo.png',
          contactPoint: {
            '@type': 'ContactPoint',
            telephone: '400-888-6666',
            contactType: 'customer service',
            availableLanguage: ['Chinese'],
          },
          sameAs: [],
        };
      case 'WebSite':
        return {
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '无遮韩国免费漫画大全',
          url: 'https://manhwa-free.com',
          description: '在韩漫漫画网站，您可以找到无遮韩国免费漫画大全并享受免费在线阅读韩漫，网站稳定性高确保访问顺畅。',
          potentialAction: {
            '@type': 'SearchAction',
            'target': {
              '@type': 'EntryPoint',
              urlTemplate: 'https://manhwa-free.com/search?q={search_term_string}',
            },
            'query-input': 'required name=search_term_string',
          },
        };
      case 'WebPage':
        return {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '无遮韩国免费漫画大全',
          description: '免费在线阅读韩漫的首选平台，提供最全面的韩国漫画资源。',
          url: 'https://manhwa-free.com',
        };
      default:
        return null;
    }
  };

  const schema = data || getDefaultSchema();

  if (!schema) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}